import { configureStore } from "@reduxjs/toolkit";

// Admin Slices
import adminChatReducer from "./admin/chatSlice";
import createAndSyncReducer from "./admin/createAndSyncSlice";
import emailReducer from "./admin/emailSlice";
import caseOkQueueReducer from "./admin/caseOkQueueSlice";
import labDetailsReducer from "./admin/labDetailsSlice";
import labPreferenceReducer from "./admin/labPreferenceSlice";
import millingSliceReducer from "./admin/millingSlice";
import adminInternalNotesReducer from "./admin/notesSlice";
import adminPartnerReducer from "./admin/partnersSlice";
import redesignCaseReducer from "./admin/redesign";
import adminRequestReducer from "./admin/requestSlice";

// Allocation Slices
import caseAllocationReducer from "./allocation/allocateSlice";
import allocationAuthReducer from "./allocation/allocationAuthSlice";
import employeeReducer from "./allocation/employeeSlice";
import employeeDashboardReducer from "./allocation/employeeDashboardSlice";
import portalReviewReducer from "./allocation/portalReviewSlice";
import readyCasesReducer from "./allocation/readyCasesSlice";
import shiftsReducer from "./allocation/shiftsSlice";
import hrReducer from "./hr/hrSlice";

// Common Slices
import authReducer from "./common/authSlice";
import adminCasesReducer from "./common/casesSlice";
import deleteBoxFilesReducer from "./common/deleteBoxFileSlice";
import fileUploadReducer from "./common/fetchBoxFileSlice";
import searchReducer from "./common/searchSlice";
import updateCaseStatusReducer from "./common/updateCaseStatusSlice";
import testimonialReducer from "./common/testimonialSlice";
import loggingReducer from "./common/loggingSlice"
import photorealisticScanReducer from "./common/photorealisticScanSlice";
import tsUploadAccessReducer from "./admin/tsUploadAccessSlice";

// Super Admin Slices
import impersonationReducer from "./superAdmin/impersonationSlice";
import invoicesReducer from "./superAdmin/invoicesSlice";
import adminRoleReducer from "./superAdmin/roleSlice";
import dataExtractReducer from "./superAdmin/dataExtractSlice";
import deliveryUnitsReducer from "./superAdmin/unitsSlice";
import markedUnitsReducer from "./superAdmin/markedUnitsSlice";
import unitsLedgerReducer from "./superAdmin/unitsLedgerSlice";
import mistakeTrackerReducer from "./admin/mistakeTrackerSlice";
import fileCheckerReducer from "./superAdmin/fileCheckerSlice";
import labBillingPricingReducer from "./superAdmin/labBillingPricingSlice";

// Smile Design
import smileGenerationReducer from "./smileDesign/smileGenerationSlice";
import smilePromptReducer from "./smileDesign/smilePromptSlice";
import smilePackageReducer from "./smileDesign/smilePackageSlice";
import smileCasesReducer from "./smileDesign/smileCasesSlice";
import paymentReducer from "./smileDesign/paymentSlice";
import smileClientsReducer from "./smileDesign/smileClientsSlice";
import videoGenerationReducer from "./smileDesign/videoGenerationSlice";


// User Slices
import userCaseReducer from "./user/userSlice";

export const store = configureStore({
  reducer: {
    // Admin Slice
    adminChat: adminChatReducer,
    createAndSync: createAndSyncReducer,
    emailSender: emailReducer,
    caseOkQueue: caseOkQueueReducer,
    labDetails: labDetailsReducer,
    labPreference: labPreferenceReducer,
    millingemails: millingSliceReducer,
    adminInternalNotes: adminInternalNotesReducer,
    adminPartner: adminPartnerReducer,
    redesignCases: redesignCaseReducer,
    adminRequestControls: adminRequestReducer,

    // Allocation
    caseAllocation: caseAllocationReducer,
    allocationAuth: allocationAuthReducer,
    employee: employeeReducer,
    employeeDashboard: employeeDashboardReducer,
    portalReviews: portalReviewReducer,
    readycases: readyCasesReducer,
    shifts: shiftsReducer,
    hr: hrReducer,

    // Common Slice
    auth: authReducer,
    adminCases: adminCasesReducer,
    deleteBoxFiles: deleteBoxFilesReducer,
    fileUpload: fileUploadReducer,
    search: searchReducer,
    updateCaseStatus: updateCaseStatusReducer,
    testimonial: testimonialReducer,
    logging: loggingReducer,
    photorealisticScan: photorealisticScanReducer,
    tsUploadAccess: tsUploadAccessReducer,
    dataExtract: dataExtractReducer,

    // Super Admin Slice
    impersonation: impersonationReducer,
    invoices: invoicesReducer,
    adminRoleControls: adminRoleReducer,
    deliveryUnits: deliveryUnitsReducer,
    markedUnits: markedUnitsReducer,
    unitsLedger: unitsLedgerReducer,
    mistakeTracker: mistakeTrackerReducer,
    fileChecker: fileCheckerReducer,
    labBillingPricing: labBillingPricingReducer,
    
    // Smile design
    smileGeneration: smileGenerationReducer,
    smilePrompt: smilePromptReducer,
    smilePackage: smilePackageReducer,
    smileCases: smileCasesReducer,
    payment: paymentReducer,
    smileClients: smileClientsReducer,
    videoGeneration: videoGenerationReducer,

    // User Slice
    userCases: userCaseReducer,

  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export default store;
